import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface Props {
  eyebrow?: ReactNode;
  title: ReactNode;
  lede?: ReactNode;
  align?: "left" | "center";
  className?: string;
}

/**
 * Consistent eyebrow + headline + lede block used across marketing
 * and learn surfaces. Uses semantic tokens only.
 */
export function SectionHeader({ eyebrow, title, lede, align = "left", className }: Props) {
  return (
    <div
      className={cn(
        "max-w-3xl",
        align === "center" && "mx-auto text-center",
        className,
      )}
    >
      {eyebrow ? (
        <div className="mb-3 font-mono-jb text-xs uppercase tracking-[0.22em] text-primary">
          {eyebrow}
        </div>
      ) : null}
      <h2 className="text-balance text-3xl font-black leading-[1.05] tracking-tight text-foreground md:text-4xl lg:text-5xl">
        {title}
      </h2>
      {lede ? (
        <p className="mt-4 text-pretty text-base leading-relaxed text-muted-foreground md:text-lg">
          {lede}
        </p>
      ) : null}
    </div>
  );
}